import React, { Component } from 'react';

class PrivacyNote extends Component {
    render() {
        return (
            <div className="privacy-note">
              <div>
                Zequencer stores copies of the project files, samples, and presets using <a href="https://ipfs.io/">IPFS</a>. 
              </div>
              <div>
                Click <a href="#">here</a> to learn how to store files directly on your computer using <a href="https://ipfs.io/">IPFS</a>.
              </div>
            </div>

        );
    }
}


export default PrivacyNote;
